import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path fillRule="evenodd"
          d="M8.96679687,10.6530599 L10.6938801,10.6530599 L10.6938801,12 L5.30611988,12 L5.30611988,10.6530599 L7.03320312,10.6530599 L7.03320312,5.34694006 L5.30611988,5.34694006 L5.30611988,4 L10.6938801,4 L10.6938801,5.34694006 L8.96679687,5.34694006 L8.96679687,10.6530599 Z"/>
  </svg>
);
